import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Did } from "../../interfaces/Did.type";

const initialState: Did[] = [];

export const didsSlice = createSlice({
    name: "dids",
    initialState,
    reducers: {
        setDidsSlice: (_, action: PayloadAction<Did[]>) => {
            return action.payload;
        },
        addDidSlice: (state, action: PayloadAction<Did>) => {
            state.push(action.payload);
        },
        deleteDidSlice: (state, action: PayloadAction<string>) => {
            return state.filter((did) => did.did !== action.payload);
        },
        updateDidSlice: (
            state,
            action: PayloadAction<{
                did: string;
                data: Partial<Did>;
            }>
        ) => {
            const index = state.findIndex((did) => did.did === action.payload.did);
            if (index !== -1) {
                state[index] = { ...state[index], ...action.payload.data };
            }
        },
    },
});

export const { setDidsSlice, addDidSlice, updateDidSlice, deleteDidSlice } = didsSlice.actions;
export default didsSlice.reducer;